import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { breakpoint, colors, spacing, typography } from '#themes/stena-recycling';
import { type BannerTypes } from './Banner';

export const BannerTitle = styled.h2`
  font: ${typography.body.mediumBold};
  display: flex;
  gap: 4px;
  align-items: center;
`;

const ErrorBanner = css`
  background-color: ${colors.alerts.errorTint3};
`;
const WarningBanner = css`
  background-color: ${colors.alerts.warningTint3};
`;
const InfoBanner = css`
  background-color: ${colors.alerts.infoTint3};
`;

export const BannerBody = styled.div`
  ${typography.body.medium};
`;

export const BannerElement = styled.div<{ type: BannerTypes; scope: string }>`
  ${({ type }) => type === 'error' && ErrorBanner}
  ${({ type }) => type === 'warning' && WarningBanner}
  ${({ type }) => type === 'info' && InfoBanner}
  ${({ scope }) =>
    scope !== 'global' &&
    css`
      border: 1px solid ${colors.monochrome.grey20};
    `}
`;

export const BannerContent = styled.div`
  padding: ${spacing.xmsmall} ${spacing.small};
  max-width: 1440px;
  margin-left: auto;
  margin-right: auto;

  @media (min-width: ${breakpoint.small}px) {
    padding-left: ${spacing.mediumHigh};
    padding-right: ${spacing.mediumHigh};
  }

  @media (min-width: ${breakpoint.large}px) {
    display: flex;
    justify-content: center;
    gap: 4px;
    align-items: center;
  }
`;
